import React, { useEffect, useState } from "react";
import {useGetUserQuery} from "../../apis/users.api";
import {createColumnHelper, flexRender, getCoreRowModel, PaginationState, useReactTable} from "@tanstack/react-table";
import {GameCategory, PlayerItem} from "../../models/User";
import {useGetTournamentLeagueRewardsQuery, useGetTournamentRankingQuery} from "../../apis/tournaments.api";
import {classNames, cssHidden, getDaysLeftLabel} from "../../utils/Helper";
import {ListLoaderComponent} from "../ui/list-loader.component";
import {GainCoinComponent} from "../ui/gain-coin.component";
import {useGetPortfolioCollectibleRewardRankQuery} from "../../apis/game.api";
import RankStatus from "../ranking/rank-status.component";
import RankReward from "../ranking/rank-reward.component";
import StickyPlayerRank from "../ranking/sticky-player-rank.component";
import { computeRewardVisibleIcons, flattenRewardsByRank } from "../../utils/RewardsUtils";
import {PlayerActionDrawerComponent} from "./player-action-drawer.component";
import {useCycle} from "../../hooks/useCycle";
import { useChampionshipRemaingDays } from "../../hooks/useTournamentRemainingDays";

const columnHelper = createColumnHelper<PlayerItem>();

export type Props = {
  gameCategory: number,
  league: number
}

const ChampionshipRankingList: React.FC<Props> = ({gameCategory, league}) => {
  const {data: user} = useGetUserQuery();
  const {data: collectibleRewardRank} = useGetPortfolioCollectibleRewardRankQuery();
  const [spiedPseudo, setSpiedPseudo] = useState<string | null>(null);
  const [isLobby, setIsLobby] = useState(true);

  const columns = [
    // columnHelper.accessor(row => row.rank, {
    //   id: 'rank',
    //   cell: info => {
    //     const rank = info.getValue();
    //     let className = "w-6 h-6 p-2 mr-2 md:w-8 md:h-8 rounded-full flex-col justify-center items-center inline-flex";
    //     return (
    //       <>
    //       <span className={className}>
    //         <RankStatus rank={Number(rank)} status={Number(rank)}/>
    //       {/* //   <span className=" text-sm font-bold">{rank}</span> */}
    //       {/* //   <RankStatus rank={Number(rank)} status={Number(rank)}/> */}
    //        </span>
    //       </>
    //     );
    //   },
    //   header: () => <span className={"font-medium text-left w-full flex  mr-4"}>#</span>,
    //   footer: info => info.column.id,
    // }),
    columnHelper.accessor(row => ({
      rank: row.leagueRank,
      status: row.leagueStatus
    }), {
      id: 'rank',
      cell: info => {
        // const rank = info.getValue();
        let className = "w-6 h-6 p-2 mr-2 md:w-8 md:h-8 rounded-full flex-col justify-center items-center inline-flex";
        return (
          <>
          <span className={className}>
            <RankStatus rank={Number(info.row.original.leagueRank)} status={Number(info.row.original.leagueStatus)}/>
          {/* //   <span className=" text-sm font-bold">{rank}</span> */}
          {/* //   <RankStatus rank={Number(rank)} status={Number(rank)}/> */}
           </span>
          </>
        );
      },
      header: () => <span className={"font-medium text-left w-full flex  mr-4"}>#</span>,
      footer: info => info.column.id,
    }),
    columnHelper.accessor(row => ({
      avatarUrl: row.avatarUrl,
      pseudo: row.pseudo,
      verified: row.verified,
      discordRole: row.discordRole,
    }), {
      id: 'pseudo',
      cell: info => (
        <div className={"flex flex-row w-full h-full justify-start items-center gap-2"}>

          <span className={"w-8 h-8 p-0.5 bg-white rounded fat-grey-shadow-1 border border-neutral-200 justify-start items-start gap-4 inline-flex"}>
            <img className="w-full h-full rounded-sm bg-white" src={info.row.original.avatarUrl || `${process.env.REACT_APP_STATIC_ASSETS}/favicon.svg`}/>
          </span>

          {/* {collectibleRewardRank && Number(info.row.original.rank) <= collectibleRewardRank &&
            <CollectibleRewardComponent widthCss={"w-5"}/>
          } */}

          {
            !isLobby && <RankReward icons={computeRewardVisibleIcons(flattenedRewards[info.row.index+1])} darkMode={false}/>
          }

          <div className="flex flex-col gap-0">
            <span className={"text-xs font-bold items-center flex w-full flex-row gap-4"}>
              <span className="flex w-full max-w-[160px] break-all overflow-hidden">{info.row.original.pseudo}</span>
            </span>
          </div>

        </div>
      ),
      header: () => <span className={"font-medium text-left w-full flex "}>User</span>,
      footer: info => info.column.id,
    }),

    columnHelper.accessor(row => ({score: row.score, initialInvestment: row.initialInvestment, gameCategory: GameCategory}), {
      id: 'trades',
      cell: info => {
        const gain: number = info.row.original.score || 0;
        const invest: number = info.row.original.initialInvestment || 0;

        return <div className={"flex flex-col justify-end pr-2"}>

          <div className={"w-full flex justify-end text-lg"}><GainCoinComponent gain={gain} size={14}/></div>

          {/* {
            gameCategory === GameCategory.INVEST_GAME &&
            <>

              <div className={"w-full flex justify-end text-lg"}><GainCoinComponent gain={gain} size={0}/></div>

              <div className={"text-xs w-full flex justify-end"}>
                <QuantityCoinComponent size={12} quantity={parseFloat(invest.toFixed(1))}/>
              </div>
            </>
          }

          {
            gameCategory === GameCategory.BET_GAME &&
            <>
              <div className={"w-full flex justify-end text-lg"}><GainCoinComponent gain={gain} size={14}/></div>

              <div className={"text-sm w-full flex justify-end"}>
                <QuantityCoinComponent size={12} quantity={parseFloat(invest.toFixed(1))}/>
                <p>Cat: {gameCategory}</p>
              </div>


            </>
          } */}



        </div>
      },
      header: () => <span className={"font-bold"}>Score</span>,
      footer: info => info.column.id,

    }),
  ]

  const [{pageIndex, pageSize}, setPagination] =
    React.useState<PaginationState>({
      pageIndex: 0,
      pageSize: 50,
    })

  const {data: playersData, isLoading: arePlayersLoading} = useGetTournamentRankingQuery({
    gameCategory,
    pageIndex,
    pageSize
  });

  useEffect(() => {
    setIsLobby( playersData?.currentPlayer.tournamentNumber === -1 );
  }, [playersData]);

  const cycle = useCycle();

  const [flattenedRewards, setFlattenedRewards] = useState([] as any);
  const {data: leagueRewardsData, isLoading: areLeagueRewardsLoading} = useGetTournamentLeagueRewardsQuery({league:league});

  useEffect(() => {
    if(leagueRewardsData){
      setFlattenedRewards(flattenRewardsByRank(leagueRewardsData));
    }
  }, [leagueRewardsData]);

  const defaultData = React.useMemo(() => [], [])

  const pagination = React.useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  )

  const table = useReactTable({
    data: playersData ? playersData.players : defaultData,
    columns,
    state: {
      pagination,
    },
    pageCount: (playersData?.totalPlayers) ? Math.ceil((playersData?.totalPlayers) / pageSize) : -1,
    getCoreRowModel: getCoreRowModel(),
    onPaginationChange: (data) => {
      window.scroll(0, 0);
      setPagination(data);
    },
    manualPagination: true,
  })

  const remainingDays = useChampionshipRemaingDays();

  return (
    <div className={"w-full max-w-md text-xxs md:text-sm"}>

      {!arePlayersLoading &&
        <div className="w-full flex center justify-between text-opacity-30">
          <span> {`Cycle ${cycle}`} </span>
          <span> {playersData?.totalPlayers} Players </span>
          {/* <span> {`${getDaysLeftLabel(remainingDays)}`} </span> */}
          <span> {`${getDaysLeftLabel(remainingDays)}`} </span>
        </div>
      }

      {arePlayersLoading &&
        <ListLoaderComponent/>
      }
      {!arePlayersLoading &&
        <table className={"w-full"}>
          <thead className={"hidden"}>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header, index, array) => (
                <th key={header.id}
                    className={`${index === 0 ? 'pl-4 w-8' : ''} ${index === array.length - 1 ? 'pr-4 md:pr-8' : ''} border-b-[1px] border-gray-300`}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                </th>
              ))}
            </tr>
          ))}
          </thead>

          <tbody>
          {table.getRowModel().rows.map(row => (
            <tr key={row.id}
                className={classNames(((user && (row.getValue('pseudo') as PlayerItem).pseudo === user.pseudo) ? '' : ''),
                  ' cursor-pointer relative')}
                onClick={() => {
                  setSpiedPseudo((row.getValue('pseudo') as any).pseudo);
                }}>
              {row.getVisibleCells().map((cell, index) => (
                <td
                  className={`
                    border-b-[1px] border-[#E6E6E6] max-w-[135px] overflow-hidden overflow-ellipsis text-xxs md:text-sm py-3
                    ${index === 0 ? 'pl-2 w-8' : ''}
                    ${(isLobby && !(index==1)) ? 'hidden' : '' }
                    `}
                  key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
          </tbody>

        </table>
      }

      <div className={classNames("flex items-center justify-center gap-8 mt-4 mb-10",cssHidden(!table.getCanPreviousPage() && !table.getCanNextPage()))}>
        <button
          className="orange-button text-sm"
          onClick={() => table.setPageIndex(0)}
          disabled={!table.getCanPreviousPage()}
        >
          {'<<'}
        </button>
        <button
          className="orange-button text-sm"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          {'<'}
        </button>
        <button
          className="orange-button text-sm"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          {'>'}
        </button>
        <button
          className="orange-button text-sm"
          onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          disabled={!table.getCanNextPage()}
        >
          {'>>'}
        </button>
        {arePlayersLoading ? 'Loading...' : null}
      </div>

      {playersData && playersData.currentPlayer &&
        <div className="fixed bottom-16 left-0 w-screen px-2 pb-3 bg-gradient-to-b from-white/0 to-white flex-col justify-start items-center gap-4 inline-flex z-30" onClick={()=>{
          setSpiedPseudo(playersData.currentPlayer.pseudo);
        }}>
          <StickyPlayerRank player={playersData.currentPlayer}/>
        </div>
      }

      <PlayerActionDrawerComponent gameCategory={gameCategory} open={!!spiedPseudo} pseudo={spiedPseudo || ''}
                                   onClose={() => setSpiedPseudo(null)}/>
    </div>
  );
}

export {ChampionshipRankingList};

